import C from "../constants";

const initialState = {
  time: 0,
  meta: {},
  error: false,
};

export default function (state, action) {
  switch (action.type) {
    case C.GET_PROGRESS_INFO:
      return {
        ...state,
        meta: {},
        time: 0,
      };
    case C.GET_PROGRESS_INFO_FAIL:
      const { formErrors } = action.error;
      return {
        ...state,
        formErrors: formErrors || undefined,
      };
    case C.GET_PROGRESS_INFO_SUCCESS:
      const { time, meta } = action.result;
      return {
        ...state,
        time: time,
        meta: meta,
      };
    default:
      return state || initialState;
  }
}
